import React from 'react';
import { imgSet } from '../lib/img';

export default function Card({ imageSrc, title, description, link }) {
  const v = imgSet(imageSrc);
  return (
    <a
      href={link || '#'}
      className="block bg-white rounded-lg overflow-hidden shadow transition-transform transform hover:scale-105"
    >
      <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
        <div className="px-4 py-5 sm:p-6">
          <img
            src={v.mid}
            srcSet={v.srcSet}
            sizes="(min-width: 640px) 50vw, 100vw"
            loading="lazy"
            decoding="async"
            alt={title}
            className="w-full max-h-70 object-cover md:max-h-80 px-3 md:px-0"
          />
        </div>
        <div className="px-4 py-4 sm:px-6">
          <h3 className="text-lg text-gray-700 font-bold">{title}</h3>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
      </div>
    </a>
  );
}
